export default __webpack_public_path__ + "static/media/RealEstate_Banner.c2373e49.png";